<template>
  <v-form ref="client-form" v-model="formValid" @input="handleFormInput">
    <v-text-field
        v-model="cl.title"
        label="Title"
        :rules="titleRules"
        required
        :errorMessages="errorMessagesByFields['title']"
        @input="handleFieldInput($event, 'title')"
    ></v-text-field>
    <v-text-field
        v-model="cl.commonTitle"
        label="Common title"
        :rules="titleRules"
        required
        :errorMessages="errorMessagesByFields['commonTitle']"
        @input="handleFieldInput($event, 'commonTitle')"
    ></v-text-field>
    <v-checkbox v-model="cl.useCommonTitleInReports"
                label="Use common title in reports"
    ></v-checkbox>
    <v-text-field
        v-model="cl.reportEmail"
        label="Report email addresses (comma separated)"
        :errorMessages="errorMessagesByFields['reportEmail']"
        @input="handleFieldInput($event, 'reportEmail')"
    ></v-text-field>
    <v-select
        :items="availableReportSendModes"
        v-model="cl.reportSendMode"
        item-value="value"
        item-text="name"
        label="Report send mode"
        persistent-hint
        required
    ></v-select>
    <period-execution-selector ref="period-execution-selector"
                               :period-execution="cl.periodExecution"
                               :available-periods="availableExecutionPeriods"
                               @validation-changed="handlePeriodExecutionSelectorValidationChange"></period-execution-selector>
    <v-text-field
        v-model="cl.contractNumber"
        label="Contract number"
        :errorMessages="errorMessagesByFields['contractNumber']"
        @input="handleFieldInput($event, 'contractNumber')"
    ></v-text-field>

    <v-menu
        v-model="contractDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
            v-model="contractDateFormatted"
            label="Contract date"
            prepend-icon="event"
            readonly
            clearable
            v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="cl.contractDate" @input="contractDateMenu = false"
                     first-day-of-week="1"></v-date-picker>
    </v-menu>
    <v-select
        :items="availableDefaultSampleTargets"
        v-model="cl.defaultSampleTarget"
        item-value="value"
        item-text="name"
        label="Default sample target"
        persistent-hint
        required
    ></v-select>
  </v-form>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import PeriodExecutionSelector from '../../Common/PeriodExecutionSelector';
import {reformatDate} from "@/helpers/timeformats";

const emptyClient = {
  id: null,
  title: null,
  reportEmail: null,
  reportSendMode: 'manual',
  contractNumber: null,
  contractDate: null,
  commonTitle: null,
  useCommonTitleInReports: false,
  defaultSampleTarget: 'analysis'
}

export default {
  name: "ClientForm",
  props: {
    client: Object,
    errorMessagesByFields: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    PeriodExecutionSelector
  },
  data() {
    return {
      cl: !this.client ? _.cloneDeep(emptyClient) : _.cloneDeep(this.client),
      titleRules: [
        v => !!v || 'Enter client title',
        v => (v && v.length <= 1000) || 'The length of the name should be no more than 1000 characters'
      ],
      formValid: false,
      contractDateMenu: false
    }
  },
  computed: {
    ...mapState('clients', {
      availableReportSendModes: 'availableReportSendModes',
      availableDefaultSampleTargets: 'availableDefaultSampleTargets'
    }),
    ...mapState({
      availableExecutionPeriods: 'availableExecutionPeriods'
    }),
    contractDateFormatted: {
      get() {
        return reformatDate(this.cl.contractDate)
      },
      set(value) {
        this.cl.contractDate = value
      }
    },
  },
  methods: {
    getFormData() {
      return {
        id: this.cl.id,
        title: this.cl.title,
        commonTitle: this.cl.commonTitle,
        useCommonTitleInReports: this.cl.useCommonTitleInReports,
        reportEmail: this.cl.reportEmail,
        reportSendMode: this.cl.reportSendMode,
        periodExecution: this.$refs['period-execution-selector'].getValue(),
        contractNumber: this.cl.contractNumber,
        contractDate: this.cl.contractDate,
        defaultSampleTarget: this.cl.defaultSampleTarget
      }
    },
    reset() {
      this.cl = !this.client ? _.cloneDeep(emptyClient) : _.cloneDeep(this.client)
    },
    validate() {
      return this.$refs['client-form'].validate() && this.$refs['period-execution-selector'].validate()
    },
    isValid() {
      return this.formValid && this.$refs['period-execution-selector'].isValid()
    },
    handleFormInput(value) {
      const patientForm = this.$refs['period-execution-selector']

      let result = value

      if (patientForm) {
        result = value && this.$refs['period-execution-selector'].isValid()
      }

      this.$emit('validation-changed', result)
    },
    handleFieldInput(value, fieldName) {
      this.$emit('fieldChanged', {
        fieldName: fieldName,
        value: value
      })
    },
    handlePeriodExecutionSelectorValidationChange(value) {
      this.$emit('validation-changed', this.formValid && value)
    }
  }
}
</script>

<style scoped>

</style>